import React, { useState, useEffect } from "react";
import { GetCommonContentReReg } from "../../../services/ProgrammeServices";
import AssignedModules from "./ModulesBlock/AssignedModule";
import { usePermissionGuardRedirect } from "../../../hooks/usePermissionGuard";

const Modules = ({ refresh, setRefresh}) => {
  const [updateRow, setUpdateRow] = useState(false);
  const [dropdownVals, setDropdownVals] = useState();

  usePermissionGuardRedirect(['pcview']);

  useEffect(() => {
    GetCommonContentReReg()
      .then((res) => {
        setDropdownVals(res.data)
      })
      .catch((err) => console.log("error :", err))
  }, []);

  return <AssignedModules setUpdateRow={setUpdateRow} updateRow={updateRow} dropdowns={dropdownVals && dropdownVals} refresh={refresh} setRefresh={setRefresh} />
};

export default Modules;
